import React from "react";
import Chart from "react-apexcharts";

function TrabajadorasChart() {
  // Datos de ejemplo basados en tu imagen (en miles)
  // capital: 10.9k, montañas: 6.1k, etc.
  const series = [
    {
      name: "Trabajadoras",
      data: [
        10900, // CAPITAL
        6100,  // LAS MONTAÑAS
        3700,  // SOTAVENTO
        2800,  // OLMECA
        2300,  // PAPALOAPAN
        2200,  // TOTONACA
        2100,  // HUASTECA BAJA
        2100,  // HUASTECA ALTA
        1500,  // NAUTLA
        1000,  // LOS TUXTLAS
      ]
    }
  ];

  const options = {
    chart: {
      type: "bar",
      height: 350
    },
    plotOptions: {
      bar: {
        horizontal: true,    // Barras horizontales
        barHeight: "70%",    // Ajusta la altura de las barras
      }
    },
    xaxis: {
      categories: [
        "CAPITAL",
        "LAS MONTAÑAS",
        "SOTAVENTO",
        "OLMECA",
        "PAPALOAPAN",
        "TOTONACA",
        "HUASTECA BAJA",
        "HUASTECA ALTA",
        "NAUTLA",
        "LOS TUXTLAS"
      ],
      labels: {
        formatter: (val) => val / 1000 + " mil", // Convierte 10900 -> "10.9 mil"
      },
      title: {
        text: "Total",  // Etiqueta del eje X
      }
    },
    yaxis: {
      title: {
        text: "región",
      }
    },
    dataLabels: {
      enabled: true,
      formatter: (val) => val / 1000 + " mil",
      offsetX: 10,
    },
    colors: ["#8B572A"], // Color café
    grid: {
      borderColor: "#e7e7e7",
      row: {
        colors: ["#f3f3f3", "transparent"], // Alterna color de filas
        opacity: 0.5
      }
    },
    tooltip: {
      y: {
        formatter: (val) => val / 1000 + " mil",
      }
    },
    title: {
      text: "Trabajadoras por región",
      align: "left",
    },
    legend: {
      show: false
    }
  };

  return (
    <div style={{ width: 600 }}>
      <Chart
        options={options}
        series={series}
        type="bar"
        height={350}
      />
    </div>
  );
}

export default TrabajadorasChart;
